export const RESPONSIVE_IMAGE = {
    responsiveImageInitialWidth: 288,
    responsiveImageInitialHeight: 162,
    thumbImageWidth: 100,
    thumbImageHeight: 100,
    userProfileHeight: 24,
    userProfileWidth: 24,
    onAirScheduleThumbHeight: 70,
    onAirScheduleThumbWidth: 70,
    showThumbWidth: 160,
    showThumbHeight: 160,
    chartListItemThumb: 72,
    musicTrackImageWidth: 56,
    stationLogoMobileWidth: 180,
    stationLogoMobileHeight: 60,
    stationLogoDesktopWidth: 300,
    stationLogoDesktopHeight: 100,
    trafficTileImageWidth: 239,
    trafficTileImageHeight: 169,
};
